<div *ngIf="isLoading; else app" class="loader-container">
    <div class="loader">Loading...</div>
</div>
<ng-template #app>
    <router-outlet></router-outlet>
</ng-template>
